function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import React from 'react';
import { colors } from '@guryou/colors';
import { TextField } from '@material-ui/core';
import PropTypes from 'prop-types';
import '../assets/inputFields.css';
const ColorBox = _ref => {
  let {
    color,
    ...rest
  } = _ref;
  if (color) {
    rest.defaultValue = color.startsWith('#') ? color : "#".concat(color);
  }
  return /*#__PURE__*/React.createElement(TextField, _extends({
    margin: "normal"
  }, rest, {
    type: "color"
  }));
};
ColorBox.propTypes = {
  name: PropTypes.string,
  color: PropTypes.string
};
ColorBox.defaultProps = {
  color: colors.mandy
};
export default ColorBox;